// authSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { handleKiloleterMasterSingleList } from "../../../Api/api";

// Define an initial state for the slice
const initialState = {
   data: null,
   loading: false,
   error: null,
};



// Create an async thunk for the login action
export const kiloleterMasterSingleListAsync = createAsyncThunk(
   "kiloleterMaster/getList",
   async ({ data, done, err }) => {
      // ;
      try {
         const { id} = data;
       //  const response = await handleCompanyMasterSingleList(id, modelId, actionId);
         const response = await handleKiloleterMasterSingleList(id);
         done && done(response.data.res);
         return response.data;
      } catch (error) {
         // You can customize the error handling here
         
         err && err();
         throw error.response.data;
      }
   }
);

// Create a slice of the Redux store
const kiloleterMasterSingleListSlice = createSlice({
   name: "kiloleterMaster",
   initialState,
   reducers: {
      // You can define additional synchronous actions here if needed
   },
   extraReducers: (builder) => {
      builder
         .addCase(kiloleterMasterSingleListAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(kiloleterMasterSingleListAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            // 
         })
         .addCase(kiloleterMasterSingleListAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload; // error message from the rejectWithValue call
         });
   },
});

// Export the reducer
export default kiloleterMasterSingleListSlice.reducer;
